import store from '@/store/'

import {apiAccountLogin,apiAccountStatus} from "@/utils/api/apiAuth.js";

export default function auth ({ next, store }){
    let accessToken = localStorage.getItem('accessToken');
    //如果有設定accessToken則設定參數狀態為登入，遠端驗證稍後再做
    if(accessToken!=null){
        store.commit('auth/setAccessToken',accessToken);
        store.commit('auth/setLogin',true);
    }

    if(store.state.auth.isLogin == false){
        console.log('false');
        return next({
            name : 'login'
        });
    }

    //向遠端確認狀態
    let bridge = this;
    apiAccountStatus().then(function(res){
        //完成即沒事
    }).catch(error=>{
        store.commit('auth/setLogin',false);
        store.commit('auth/setAccessToken',null);
    });

    return next()
}